import { createSlice } from "@reduxjs/toolkit";
import { genderNameValidation } from "../../../utils/helper";
const initialState = {
  crmOTP: [],
  isLoading: false,
  error: "",
  hasData: false,
  codeStatus: "pending"
};
const crmOTPSlice = createSlice({
  name: "crmotpSection",
  initialState,
  reducers: {
    sendCRMOTPPending: state => {
      state.isLoading = true;
      state.codeStatus = "pending";
    },
    sendCRMOTPSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.crmOTP = action.payload;
      state.codeStatus = "success";
      sessionStorage.setItem("customerID", action.payload.profileDetail.customerID);
      sessionStorage.setItem("FirstName", action.payload?.profileDetail?.firstName);
      sessionStorage.setItem("profileName", action.payload?.profileDetail?.firstName);
      localStorage.setItem("isCRMLoggedIn", JSON.stringify(true));
      localStorage.setItem("isROPLoggedIn", JSON.stringify(false));
      window.dispatchEvent(new Event("storage"));
      let fullName = "";
      fullName = action.payload.profileDetail?.salutation + " " + action.payload.profileDetail?.firstName + " " + action.payload?.profileDetail?.lastName;
      const validateFullName = genderNameValidation(fullName);
      sessionStorage.setItem("FullName", validateFullName);
    },
    sendCRMOTPFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.codeStatus = "failure";
    },
    resetCRMOTPData: state => {
      state.codeStatus = "pending";
      state.error = "";
      state.crmOTP = [];
      state.hasData = false;
    }
  }
});
export const {
  sendCRMOTPPending,
  sendCRMOTPSuccess,
  sendCRMOTPFailure,
  resetCRMOTPData
} = crmOTPSlice.actions;
export default crmOTPSlice.reducer;